module.exports = __webpack_public_path__ + "5388f07fd846de934708ea3742d380b8.MP3";